const _none = "none"
const _forwards = "forwards"
const _backwards = "backwards"
const _both = "both"
const config = { "none": _none, "forwards": _forwards, "backwards": _backwards, "both": _both,  }
export { config as default, _none, _forwards, _backwards, _both }